
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"38","height":"38","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M19 .333a9.33 9.33 0 00-9.333 9.333A9.33 9.33 0 0019 19a9.33 9.33 0 009.333-9.334A9.33 9.33 0 0019 .333zm4.667 9.333A4.68 4.68 0 0019 5a4.68 4.68 0 00-4.667 4.666A4.68 4.68 0 0019 14.333a4.68 4.68 0 004.667-4.667zM33 33c-.467-1.657-7.7-4.667-14-4.667-6.277 0-13.463 2.987-14 4.667h28zM.333 33c0-6.207 12.437-9.334 18.667-9.334 6.23 0 18.667 3.127 18.667 9.334v4.666H.333V33z","fill":"#9AA0B5"}})])
          )
        }
      }
    